import React, { Fragment, useEffect, useRef, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Box,
    Button,
    colors,
    Container,
    CssBaseline,
    FormControlLabel,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesAutoPurch,
    useStylesLbl,
    useStylesAutoSafe,
} from '../../../../St/Reports/UseStyle';
import AddIcon from "@material-ui/icons/Add";

import CircularProgress from "@material-ui/core/CircularProgress";
import {
    useStylesAuto,
    useStylesTF,
    SaleSwitch,
} from "../../../../St/comps/UseStyle";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import StopIcon from "@material-ui/icons/Stop";
import QuestionAnswer from "@material-ui/icons/Update";
import moment from "moment";
import i18next from "i18next";
import { checkValueQ, getAlertValQ } from "../components/ShareFunctionsInv";
import { CloudUpload, Search } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        // backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold"
    },
    headerTitle2: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    headerTitleP: {
        backgroundColor: colors.blue[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));
export const IsharLevels = [
    { id: 0, name: "حسب الفاتورة" },
    { id: 1, name: "حسب الأصناف" },
];

export default function MainInvoiceHeader(props) {
    const {
        AutoOptions,
        isPurches,
        setting,
        handleOpenCustomer,
        changAutoCustomers
        , optionsCustomers,
        changAutoSalesMen,
        valueSalesmen,
        changAutoCostcenter,
        valueCostcenter,
        idata,
        changAutoType,
        valueType,
        valueSafes,
        changAutoSafes,
        changAutoStock,
        valueStock,
        changAutoBank,
        valueBank,
        changSwitch,
        uiElement,
        switchState,
        lbl,
        claslbl,
        gets,
        handleFocus,
        onChangeData,
        rptParams,
        setShowPaid,
        exsub,
        handClickInvs,
        infoInv,
        changIdata,
        omlaValue,
        showPaid,
        onChangeAutoDataSubCurr,
        clasCAB,
        changInvs,
        loading,
        toWhere,
        buttonClassnameSavetmp,
        changAutoOmla,
        SaleCheckbox,
        valueCustomers,
        itmTble,
        footerInvoices,
        maxShifts,
        isStock,
        isMake,
        idSearch,
        permistionInv,
        getCustomerData,
        showCarOptions,
        setShowCarOptions,
        onChangeCarData,
        carOptions,
        isdata,
        or,
        isOpenUpdate,
        isUpdateDate,
        downNormalItems,
        getNewItamsData,
        keepDate,
        setKeepDate,
        inputRef,
        addnewItems,
        getBarcodeMulti,
        localCashe,
        getBarcodeMezan,
        optionsItemsSearch,
        handleInputSearch,
        handleInputSearchCust,
        handleIconSearch,
        handleIconSearchCust,
        searchCustText,
        searchText,
        autoNormal,
        downItemsType,
        setOpenGetItems,
        getNewItemData,
        getBarcodeFast,
        valueIsharLevel,
        changAutoIsharLevel,
        changeIdataIshar,
        playSuccess,
        getCodeDiscount,
        getCarData
    } = props;

    const { t } = useTranslation(["forms"]);

    const calsPurch = useStylesAutoPurch();
    const claslbls = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasSaf = useStylesAutoSafe();
    const classes = useStyles();
    let hideCust = permistionInv?.DISCUST ?? false;

    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

    const getoptionlbl2 = (option) => {
        return `${option?.name == null ? "" : option?.nameE == null ? option?.name : option?.name + '-' + option?.nameE ?? ""}`
    };
    const getoptionlbl = (option) => {
        return `${option?.id == null ? t("search_for_id_item") : option?.id}`
    };

    let dueDate = idata?.Due_date == null || idata?.Due_date == "" ? moment(new Date()).format("YYYY-MM-DD") : idata?.Due_date;
    let delDate = idata?.Delivery_date == null || idata?.Delivery_date == "" ? moment(new Date()).format("YYYY-MM-DD") : idata?.Delivery_date;

    let notUpdate = or?.postput === "toPut" && !isOpenUpdate ? true : false;
    let HideItems = permistionInv?.HIDEITEM == null ? false : permistionInv?.HIDEITEM;

    const buffer = useRef("");
    const [queue, setQueue] = useState([]);
    const [proccessing, setProccessing] = useState(false);

    useEffect(() => {
        if (inputRef.current && autoNormal) {
            inputRef.current.focus();
        }
    }, [inputRef]);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {

            e.preventDefault();
            const code = e.target.value.trim();
            if (code !== "") {
                setQueue(prev => [...prev, code]);
                buffer.current = "";
                if (inputRef.current) {
                    inputRef.current.value = "";
                }
            }
            e.target.value = "";
        }
        if (e.key.length !== 1) return;
        buffer.current += e.key;

    };

    useEffect(() => {
        if (!proccessing && queue.length > 0) {
            proccessNext();
        }
    }, [queue, proccessing, rptParams, localCashe, permistionInv, isdata, AutoOptions]);

    const proccessNext = async () => {
        if (queue.length === 0) return;
        setProccessing(true);
        const barcode = queue[0];
        try {
            if (AutoOptions?.permType?.id === 6) {
                await getNewItemData(barcode, false, true);
            } else {
                const isMezan = permistionInv?.USEMEZAN && (barcode.length === 13 || barcode.length === 18) &&
                    (barcode.startsWith("99") || barcode.startsWith("21") || barcode.startsWith("27")) ? true : false;
                const newItem = localCashe.find((obj) => obj.item.barcode.toString() === barcode.toString());
                if (newItem && !isMezan) {
                    let oldVal = 0;
                    let totValbef = 0.0;
                    if (permistionInv.SIM == false) {
                        for (let m = 0; m < isdata.length; m++) {
                            if (newItem?.item?.curr == isdata[m].currency_from)
                                totValbef += (isdata[m].val1 * isdata[m].val);
                        };
                        oldVal = Number(newItem.val) - totValbef;
                    }
                    if (checkValueQ(setting, permistionInv, newItem?.item?.ctype, oldVal) == 0) {
                        getAlertValQ(valueSafes, newItem.val, newItem?.item?.curr, newItem?.item?.perc);
                    } else {
                        await addnewItems({ ...newItem?.item }, { ...newItem?.unit }, newItem.units, newItem.val, true);
                        playSuccess();
                    }
                }
                else {
                    if (permistionInv?.SIM && permistionInv?.JRDSH) {
                        await getBarcodeFast(barcode, false, true);
                    } else {
                        if (isMezan)
                            await getBarcodeMezan(barcode);
                        else
                            await getBarcodeMulti(barcode, false, true);
                    }
                }
            }
        } catch (e) { }
        setQueue(pref => pref.slice(1));
        setProccessing(false)
    };

    const downAutoItems = () => {
        return (
            <>
                <Grid item lg={2} md={2} sm={3} xs={8} style={{ paddingBottom: "0.5rem" }}>
                    <TextField
                        inputRef={inputRef}
                        type="text"
                        fullWidth
                        variant="outlined"
                        inputMode="none"
                        size="small"
                        id="barcode"
                        // disabled={notUpdate}
                        disabled={["149", "150"].includes(setting.PrTy_InPr) || notUpdate}
                        label={t("forms:barcode")}
                        style={{ backgroundColor: setting.PrTy_InPr === "03" ? colors.yellow[50] : isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                        name="barcode"
                        autoFocus={true}
                        autoComplete="off"
                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                        // onKeyDown={handleKeyDown}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                handleKeyDown(event);
                            }
                        }}
                        onFocus={handleFocus}
                        onChange={onChangeData("barcode")}
                    />
                </Grid>
                {idSearch ? (
                    <Grid item lg={2} md={2} sm={4} xs={7} style={{ paddingBottom: "0.5rem" }}>
                        <Autocomplete classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                            value={rptParams.curr}
                            // onInputChange={handleInputSearch}
                            options={AutoOptions.InvItems}
                            noOptionsText={t("search_for_id_item")}
                            getOptionLabel={(option) =>
                                getoptionlbl(option)
                            }
                            disabled={notUpdate}
                            disableClearable
                            style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                            fullWidth
                            variant="outlined"
                            size="small"
                            autoFocus={false}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("search_for_id_item")}
                                    variant="outlined"
                                    id="searchIdItem"
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                />
                            )}
                            onChange={(event, newValue) => {
                                onChangeAutoDataSubCurr("curr", newValue);
                            }}
                        />
                    </Grid>
                ) : (
                    <Grid item lg={2} md={2} sm={4} xs={7} id="searchItemName" style={{ paddingBottom: "0.5rem" }}>
                        <Autocomplete
                            id="searchItemName1"
                            value={rptParams.curr}
                            onInputChange={(event, newValue, reason) => {
                                if (reason === "input") handleInputSearch(event, newValue, reason);
                            }}
                            options={optionsItemsSearch}
                            noOptionsText={t("search_item")}
                            getOptionLabel={(option) =>
                                getoptionlbl2(option)
                            }
                            disableClearable
                            style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                            fullWidth
                            // disabled={notUpdate}
                            disabled={["149", "150"].includes(setting.PrTy_InPr) || notUpdate}
                            variant="outlined"
                            size="small"
                            autoFocus={false}
                            freeSolo={true}
                            // id="controllable-states-demo"
                            renderInput={(params) => (
                                <Box ize="small" display={"flex"} textAlign={"center"}>
                                    <TextField
                                        {...params}
                                        label={t("search_item")}
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        textAlign={"center"}
                                        id="searchItemName3"
                                        onKeyDown={(event) => {
                                            if (event.ctrlKey && event.altKey) {
                                                event.preventDefault();
                                                handleIconSearch(event);
                                            }
                                        }}
                                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    />
                                    {searchText != "" && (
                                        <IconButton size="small" onClick={handleIconSearch}>
                                            <Search />
                                        </IconButton>
                                    )}
                                </Box>
                            )}
                            onChange={(event, newValue) => {
                                onChangeAutoDataSubCurr("curr", newValue);
                            }}

                        />
                    </Grid>
                )}

            </>
        );
    };
    const disbleIshar = ["149", "150"].includes(setting.PrTy_InPr) && (permistionInv?.USE_ISHAR == false
        || permistionInv?.USE_ISHAR == undefined || permistionInv?.USE_ISHAR == null) ? true : false;


    return (
        <div className={classes.root}>

            <Typography
                component="div"
                className="notranslate"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr", }}
            >
                <CssBaseline />
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: isPurches ? "#008080" : isStock ? "#3f51b5" : isMake ? "#c74375" :
                            ["149", "150"].includes(setting.PrTy_InPr) ? "#FF1493" : colors.green[300],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >
                    <React.Fragment>
                        <Grid container style={{ padding: 5 }} spacing={1} >
                            {permistionInv?.REGNOCUST ? (
                                <Grid item lg={2} md={2} sm={3} xs={8} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small"
                                        id="customer_name"
                                        label={t("customer")}
                                        className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                        type="text"
                                        name="customer_name"
                                        value={idata?.customer_name}
                                        onChange={changIdata("customer_name")}
                                    />
                                </Grid>
                            ) : (
                                <>
                                    {!hideCust &&
                                        <Grid
                                            item
                                            style={{
                                                paddingRight: "10px",
                                                color: setting.PrTy_InPr === "03" ? "#964B00" : isPurches ? colors.blue[500] : isStock ? colors.blue[500] : isMake ? colors.blue[500] : colors.green[50],
                                                textAlign: "-webkit-center",
                                            }}
                                        >
                                            <IconButton
                                                color="inherit"
                                                style={{
                                                    background: ["149", "150"].includes(setting.PrTy_InPr) ? "#FF1493" : setting.PrTy_InPr === "03" ? "#964B00" : isPurches ? "#008080" : isStock ? "#3f51b5" : isMake ? "#c74375" : colors.green[500],
                                                    padding: "10px",
                                                    color: "#fff",
                                                }}
                                                aria-label="open drawer"
                                                disabled={["149", "150"].includes(setting.PrTy_InPr)}
                                                onClick={handleOpenCustomer}
                                            >
                                                <AddIcon />
                                            </IconButton>
                                        </Grid>
                                    }
                                    <Grid item lg={2} md={2} sm={3} xs={8} style={{ paddingBottom: "0.5rem" }}>

                                        <Autocomplete classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                            value={valueCustomers}
                                            onInputChange={(event, newValue, reason) => {
                                                if (reason === "input") handleInputSearchCust(event, newValue, reason);
                                            }}
                                            size="small"
                                            options={optionsCustomers}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.name
                                            }
                                            style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                                            disabled={["149", "150"].includes(setting.PrTy_InPr) || notUpdate}
                                            disableClearable
                                            renderInput={(params) => (
                                                <Box size="small" display={"flex"} textAlign={"center"}>
                                                    <TextField
                                                        {...params}
                                                        label={setting.cusType == 1 ? t("customer") : t("supplier")}
                                                        variant="outlined"
                                                        fullWidth
                                                        size="small"
                                                        textAlign={"center"}
                                                        id="searchCust"
                                                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : isMake ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                                    />
                                                    {searchCustText != "" &&
                                                        (
                                                            <IconButton size="small" onClick={handleIconSearchCust}>
                                                                <Search />
                                                            </IconButton>
                                                        )}
                                                </Box>
                                            )}
                                            onChange={(event, newValue) => {
                                                changAutoCustomers(newValue);
                                            }}
                                        />
                                    </Grid>
                                    {!hideCust &&
                                        <Grid
                                            item

                                            style={{
                                                paddingRight: "2px",
                                                color: isPurches ? colors.blue[500] : isStock ? colors.blue[500] : colors.green[50],
                                                textAlign: "-webkit-center",
                                            }}
                                        >
                                            <IconButton
                                                color="inherit"
                                                style={{
                                                    background: "#fff",
                                                    padding: "5px",
                                                    color: ["149", "150"].includes(setting.PrTy_InPr) ? "#FF1493" : isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[900],
                                                }}
                                                aria-label="open drawer"
                                                disabled={["149", "150"].includes(setting.PrTy_InPr)}
                                                onClick={() => {
                                                    getCustomerData();
                                                }}
                                            >
                                                <QuestionAnswer />
                                            </IconButton>
                                        </Grid>
                                    }
                                </>)}
                            <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    id="id"
                                    label={t("invoice-id")}
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputProps={{ className: isPurches ? claslbl.clrPurch : isStock ? claslbls.clrBlackLblS : claslbls.clrSale, readOnly: true }}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                    type="text"
                                    name="id" value={infoInv.id}
                                />
                            </Grid>

                            <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    id="refno"
                                    label={t("ref-no")}
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                    type="text"
                                    name="refno"
                                    value={idata.refno}
                                    onChange={changIdata("refno")}
                                />
                            </Grid>
                            <Grid item lg={1} md={1} sm={3} xs={5} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small" id="date"
                                    label={t("date")}
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    type="date" format="YYYY-MM-DD"
                                    name="date"
                                    disabled={setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12" ? AutoOptions?.StepTwo?.id == 1 ? isUpdateDate ? false : true : !permistionInv.UPD : !permistionInv.UPD}
                                    value={idata.date}
                                    onChange={changIdata("date")}
                                /></Grid>
                            <Hidden smDown>
                                {setting.PrTy_InPr === "01" &&
                                    (
                                        <FormControlLabel
                                            id="showPaid"
                                            value="showPaid"
                                            name="showPaid"
                                            className={claslbl.clor}
                                            control={
                                                <SaleCheckbox
                                                    checked={keepDate}
                                                    onChange={(e) => {
                                                        setKeepDate(e.target.checked);
                                                    }}
                                                    color="primary"
                                                />
                                            }
                                            label={""}
                                            labelPlacement="start"
                                        />
                                    )}
                            </Hidden>

                            <Grid item lg={1} md={1} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete
                                    classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                    value={valueSalesmen}
                                    onChange={(event, newValue) => {
                                        changAutoSalesMen(newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={gets.salesmen}
                                    disabled={AutoOptions?.salesuser?.id == -1 || AutoOptions?.salesuser?.id == 0 ? false : true}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            id="sales_man"
                                            {...params}
                                            label={t("delegate")}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                        />
                                    )}
                                />

                            </Grid>
                            <Grid item lg={1} md={1} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete
                                    classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                    value={valueType}
                                    onChange={(event, newValue) => {
                                        changAutoType(newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={AutoOptions.types}
                                    disabled={[6, 7, 8].includes(valueCustomers?.Cust_inv_type ?? 0) || permistionInv?.CANCELAGEL ? true : notUpdate}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            id="typeinvs"
                                            {...params}
                                            label={t("invoice-type")}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblS }}
                                        />
                                    )}
                                />

                            </Grid>

                            <Grid item lg={1} md={1} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete
                                    classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                    value={valueCostcenter}
                                    onChange={(event, newValue) => {
                                        changAutoCostcenter(newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={gets.costcenters}
                                    disabled={notUpdate}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            id="center"
                                            {...params}
                                            label={t("center")}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbl.clrSale }}
                                        />
                                    )}
                                />

                            </Grid>

                            <Grid item lg={1} md={1} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                    value={valueSafes}
                                    onChange={(event, newValue) => {
                                        changAutoSafes(newValue);
                                    }}
                                    id="combo-box-demo"
                                    size="small"
                                    options={AutoOptions.Safes}
                                    disabled={notUpdate}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }

                                    style={{}}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t("safe")}
                                            variant="outlined"
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                        />
                                    )}

                                />
                            </Grid>
                            {uiElement.bank == true && (
                                <Grid item lg={1} md={1} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                    <Autocomplete
                                        classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                        value={valueStock}
                                        onChange={(event, newValue) => {
                                            changAutoStock(newValue);
                                        }}
                                        id="controllable-states-demo"
                                        size="small"
                                        options={AutoOptions.Stocks}
                                        disabled={notUpdate}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                id="bank"
                                                {...params}
                                                label={t("account")}
                                                variant="outlined"
                                                size="small"
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                            />
                                        )}
                                    />

                                </Grid>
                            )}

                            {uiElement.bank == false && (
                                <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                    <Autocomplete
                                        classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                        value={valueBank}
                                        onChange={(event, newValue) => {
                                            changAutoBank(newValue);
                                        }}
                                        id="controllable-states-demo"
                                        size="small"
                                        options={AutoOptions.Banks}
                                        disabled={notUpdate}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                id="bank"
                                                {...params}
                                                label={t("account")}
                                                variant="outlined"
                                                size="small"
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                            />
                                        )}
                                    />

                                </Grid>
                            )}
                            <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                                <FormControlLabel
                                    control={
                                        <Tooltip title="التبديل بين شبكة وكاش">
                                            <Grid item lg={1} md={1} sm={2} xs={3}>
                                                <SaleSwitch
                                                    size="small"
                                                    disabled={permistionInv?.CANCELBANK || permistionInv?.CANCELNET ? true : or.postput === "toPut" ? notUpdate : uiElement.payMethod}
                                                    checked={switchState.cashORnetworksw}
                                                    onChange={changSwitch("cashORnetworksw")}
                                                    id="cashORnetworksw"
                                                    value="cashORnetworksw"
                                                    name="cashORnetworksw"
                                                />
                                            </Grid>
                                        </Tooltip>
                                    }
                                    className={claslbl.clorSw}
                                    label={lbl.chashNetwork}
                                    labelPlacement="start"
                                />
                            </Grid>

                            <Hidden only={"xs"}>
                                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small"
                                        id="trans_no"
                                        label={t("shift_no")}
                                        className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                        InputProps={{ className: isPurches ? claslbl.clrPurch : isStock ? claslbls.clrBlackLblS : claslbls.clrSale, readOnly: true }}
                                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                        type="text"
                                        name="trans_no" value={maxShifts}
                                    />
                                </Grid>

                            </Hidden>

                            <Hidden mdDown>
                                {setting.PrTy_InPr === "02" &&
                                    (
                                        <>
                                            <Grid item lg={1} md={1} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                                <TextField fullWidth variant="outlined"
                                                    size="small" id="Due_date"
                                                    label={"تاريخ التوريد"}
                                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                                    type="date" format="YYYY-MM-DD"
                                                    name="Delivery_date"
                                                    value={delDate}
                                                    onChange={changIdata("Delivery_date")}
                                                /></Grid>
                                            <Grid item lg={1} md={1} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                                <TextField fullWidth variant="outlined" size="small" id="Due_date"
                                                    label={"تاريخ الاستحاق"}
                                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                                    type="date" format="YYYY-MM-DD"
                                                    name="Due_date"
                                                    value={dueDate}
                                                    onChange={changIdata("Due_date")}
                                                /></Grid>
                                        </>
                                    )}
                            </Hidden>
                            <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete
                                    classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                    value={omlaValue}
                                    onChange={(event, newValue) => {
                                        changAutoOmla(newValue);
                                    }}
                                    id="combo-box-demo"
                                    size="small"
                                    options={gets.omlats}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }

                                    style={{}}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t("currency")}
                                            variant="outlined"
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                        />
                                    )}

                                />
                            </Grid>
                            {/* for items */}
                            <Hidden mdUp>
                                {downAutoItems()}
                            </Hidden>
                            {/* for items */}

                            <Hidden smDown>
                                {autoNormal &&
                                    (
                                        downAutoItems()
                                    )}
                            </Hidden>
                            {!HideItems && (
                                <Hidden only={"xs"}>

                                    <Grid
                                        item

                                        style={{
                                            paddingRight: "10px",
                                            color: isPurches ? colors.blue[500] : isStock ? "#3f51b5" : colors.green[50],
                                            textAlign: "-webkit-center",
                                        }}
                                    >
                                        <IconButton
                                            color="inherit"
                                            style={{
                                                background: setting.PrTy_InPr === "03" ? "#964B00" : isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[500],
                                                padding: "10px",
                                                color: "#fff",
                                            }}
                                            aria-label="open drawer"
                                            disabled={["149", "150"].includes(setting.PrTy_InPr)}
                                            onClick={getNewItamsData}
                                        >
                                            <AddIcon />
                                        </IconButton>
                                    </Grid>
                                </Hidden>
                            )}


                            <Hidden smUp>
                                {exsub > 0 ? (
                                    <Grid item lg={2} md={2} sm={2} xs={2}>
                                        <div className={clasCAB.wrapperCAB}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                style={{
                                                    ...{
                                                        background: "#ff8080",
                                                        color: "#fff",
                                                        direction: "initial",
                                                    },
                                                }}
                                                className={buttonClassnameSavetmp}
                                                disabled={loading.savetmp}
                                                onClick={() => toWhere("savetmp", "e")}
                                                startIcon={<StopIcon />}
                                            >
                                            </Button>
                                            {loading.savetmp && (
                                                <CircularProgress
                                                    size={24}
                                                    className={clasCAB.buttonProgressCAB}
                                                />
                                            )}
                                        </div>
                                    </Grid>
                                ) : null}
                                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                                    <FormControlLabel
                                        id="showPaid"
                                        value="showPaid"
                                        name="showPaid"
                                        className={claslbl.clor}
                                        control={
                                            <SaleCheckbox
                                                checked={showPaid}
                                                onChange={(e) => {
                                                    setShowPaid(e.target.checked);
                                                    // changeIsPay(e.target.checked);
                                                }}
                                                color={isPurches ? "#008080" : isStock ? "#3f51b5" : "primary"}
                                            />
                                        }
                                        label={t("paids")}
                                        labelPlacement="end"
                                    />
                                </Grid>
                            </Hidden>
                            <Hidden only={"xs"}>
                                <Grid item lg={1} md={1} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                    <FormControlLabel
                                        id="showPaid"
                                        value="showPaid"
                                        name="showPaid"
                                        className={claslbl.clor}
                                        control={
                                            <SaleCheckbox
                                                checked={showPaid}
                                                onChange={(e) => {
                                                    setShowPaid(e.target.checked);
                                                    // changeIsPay(e.target.checked);
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label={t("paid_screen")}
                                        labelPlacement="end"
                                    />
                                </Grid>
                                {exsub > 0 && isdata?.length != 0 ? (
                                    <Grid item lg={1} md={1} sm={2} xs={3}>
                                        <div className={clasCAB.wrapperCAB}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="medium"
                                                style={{
                                                    ...{
                                                        background: "#ff8080",
                                                        color: "#fff",
                                                        direction: "initial",
                                                    },
                                                }}
                                                className={buttonClassnameSavetmp}
                                                disabled={loading.savetmp}
                                                onClick={() => toWhere("savetmp", "e")}
                                                startIcon={<StopIcon />}
                                            >
                                                {"F8"} {t("invoice-suspension")}
                                            </Button>
                                            {loading.savetmp && (
                                                <CircularProgress
                                                    size={24}
                                                    className={clasCAB.buttonProgressCAB}
                                                />
                                            )}
                                        </div>
                                    </Grid>
                                ) : null}
                            </Hidden>
                            {["11", "12", "149", "150"].includes(setting.PrTy_InPr) ? (
                                <Fragment>
                                    <Grid item lg={1} md={1} sm={2} xs={6}>
                                        <TextField
                                            type="number"
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="InvId_Return"
                                            label={t("return_no")}
                                            // className={clasTF.root}
                                            // InputProps={{ className: clasTF.input }}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                            // InputProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                            name="InvId_Return"
                                            value={infoInv.InvId_Return}
                                            disabled={disbleIshar}
                                            onChange={changInvs("InvId_Return")}
                                            InputProps={{
                                                onKeyDown: (event) => {
                                                    if (event.key === 'Enter') {
                                                        handClickInvs(event);
                                                        // document.getElementById("val11").focus();
                                                    }
                                                },
                                                className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale
                                            }}
                                            placeholder=""
                                        />
                                    </Grid>

                                    <Grid item lg={1} md={1} sm={1} xs={2}>
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            fontSize="large"
                                            size="medium"
                                            disabled={disbleIshar}
                                            onClick={handClickInvs}
                                        >
                                            {t("download")}
                                        </Button>
                                    </Grid>
                                </Fragment>
                            ) : (
                                <Fragment></Fragment>
                            )}


                            {(setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11") && permistionInv?.SHOWCAR &&

                                <Hidden only={"xs"}>
                                    <Grid item lg={2} md={2} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <FormControlLabel
                                            id="showPaid"
                                            value="showPaid"
                                            name="showPaid"
                                            className={claslbl.clor}
                                            control={
                                                <SaleCheckbox
                                                    checked={showCarOptions}
                                                    onChange={(e) => {
                                                        setShowCarOptions(e.target.checked);
                                                    }}
                                                    color="primary"
                                                />
                                            }
                                            label={t("show_car_options")}
                                            labelPlacement="end"
                                        />
                                    </Grid>
                                </Hidden>
                            }

                            {(showCarOptions || AutoOptions?.permType?.id === 8) && (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11") &&
                                <Hidden only={"xs"}>
                                    <Grid item xs={12} container spacing={1} >

                                        <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                            <TextField fullWidth variant="outlined" size="small"
                                                id="col1"
                                                label={AutoOptions?.permType?.id === 8 ? "الطول " : premiApp?.cashirTemplate == 5 ? t("car_model") : t("car_name")}
                                                className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                                type="text"
                                                name="refno"
                                                value={carOptions.CarModel}
                                                onChange={onChangeCarData("CarModel")}
                                                InputProps={{
                                                    className: claslbl.clrBlackTxt,
                                                    onKeyDown: (event) => {
                                                        if (event.key === 'Enter') {
                                                            document.getElementById("col2").focus();  
                                                           
                                                        }
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                            <TextField fullWidth variant="outlined" size="small"
                                                id="col2"
                                                label={AutoOptions?.permType?.id === 8 ? "الصدر" : t("plate_number")}
                                                className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                                type="text"
                                                name="CarPlatNum"
                                                value={carOptions.CarPlatNum}
                                                onChange={onChangeCarData("CarPlatNum")}
                                                onFocus={handleFocus}
                                                InputProps={{
                                                    className: claslbl.clrBlackTxt,
                                                    onKeyDown: (event) => {
                                                        if (event.key === 'Enter') {
                                                            if (!showCarOptions){
                                                                document.getElementById("col3").focus();
                                                            }else{
                                                                getCarData();
                                                                document.getElementById("col3")?.focus();
                                                            }
                                                        }
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                            <TextField fullWidth variant="outlined" size="small"
                                                id="col3"
                                                label={AutoOptions?.permType?.id === 8 ? "طول الكم" : t("made_year")}
                                                className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                                type="text"
                                                name="refno"
                                                value={carOptions.CarYear}
                                                onChange={onChangeCarData("CarYear")}
                                                onFocus={handleFocus}
                                                InputProps={{
                                                    className: claslbl.clrBlackTxt,
                                                    onKeyDown: (event) => {
                                                        if (event.key === 'Enter') {
                                                            document.getElementById("col4").focus();
                                                        }
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                            <TextField fullWidth variant="outlined" size="small"
                                                id="col4"
                                                label={AutoOptions?.permType?.id === 8 ? "الابط" : premiApp?.cashirTemplate == 5 ? t("car_model2") : t("engine_type")}
                                                className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                                type="text"
                                                name="CarType"
                                                value={carOptions.CarType}
                                                onChange={onChangeCarData("CarType")}
                                                onFocus={handleFocus}
                                                InputProps={{
                                                    className: claslbl.clrBlackTxt,
                                                    onKeyDown: (event) => {
                                                        if (event.key === 'Enter') {
                                                            document.getElementById("col5").focus();
                                                        }
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                            <TextField fullWidth variant="outlined" size="small"
                                                id="col5"
                                                label={AutoOptions?.permType?.id === 8 ? "فتحة الكم" : premiApp?.cashirTemplate == 5 ? t("return_on_km") : t("structure")}
                                                className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                                type="text"
                                                name="CarStructure"
                                                value={carOptions.CarStructure}
                                                onChange={onChangeCarData("CarStructure")}
                                                onFocus={handleFocus}
                                                InputProps={{
                                                    className: claslbl.clrBlackTxt,
                                                    onKeyDown: (event) => {
                                                        if (event.key === 'Enter') {
                                                            document.getElementById("col6").focus();
                                                        }
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={1} md={1} sm={1} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                            <TextField fullWidth variant="outlined" size="small"
                                                id="col6"
                                                label={AutoOptions?.permType?.id === 8 ? "الورك" : t("car_vactor")}
                                                className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                                type="text"
                                                name="CarVactor"
                                                value={carOptions.CarVactor}
                                                onChange={onChangeCarData("CarVactor")}
                                                onFocus={handleFocus}
                                                InputProps={{
                                                    className: claslbl.clrBlackTxt,
                                                    onKeyDown: (event) => {
                                                        if (event.key === 'Enter') {
                                                            document.getElementById("col7").focus();
                                                        }
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                            <TextField fullWidth variant="outlined" size="small"
                                                id="col7"
                                                label={AutoOptions?.permType?.id === 8 ? "" : premiApp?.cashirTemplate == 5 ? t("number_of_km") : t("color")}
                                                className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                                type="text"
                                                name="CarColor"
                                                onFocus={handleFocus}
                                                value={carOptions.CarColor}
                                                onChange={onChangeCarData("CarColor")}
                                            />
                                        </Grid>


                                    </Grid>

                                </Hidden>
                            }
                            {premiApp.billTemplate === 32 && (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11") && (
                                <Hidden smDown>
                                    <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <TextField fullWidth variant="outlined" size="small"
                                            id="OrderTypeA"
                                            label={"اسم المشروع"}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                            type="text"
                                            name="refno"
                                            value={idata.OrderTypeA}
                                            onChange={changIdata("OrderTypeA")}
                                        />
                                    </Grid>
                                    <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <TextField fullWidth variant="outlined" size="small"
                                            id="OrderTypeE"
                                            label={"رقم البائع"}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                            type="text"
                                            name="OrderTypeE"
                                            value={idata.OrderTypeE}
                                            onChange={changIdata("OrderTypeE")}
                                        />
                                    </Grid>
                                    <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <TextField fullWidth variant="outlined" size="small"
                                            id="po_no"
                                            label={"Po No"}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                            type="text"
                                            name="po_no"
                                            value={idata.po_no}
                                            onChange={changIdata("po_no")}
                                        />
                                    </Grid>
                                </Hidden>
                            )}
                            <Hidden smDown>
                                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                                    <FormControlLabel
                                        control={
                                            <Tooltip title="التبديل بين اوتماتيك وعادي">
                                                <Grid item lg={1} md={1} sm={2} xs={3}>
                                                    <SaleSwitch
                                                        size="small"
                                                        disabled={["149", "150"].includes(setting.PrTy_InPr) || notUpdate}
                                                        checked={autoNormal}
                                                        onChange={downItemsType()}
                                                        id="cashORnetworksw"
                                                        value="cashORnetworksw"
                                                        name="cashORnetworksw"
                                                    />
                                                </Grid>
                                            </Tooltip>
                                        }
                                        className={claslbl.clorSw}
                                        label={autoNormal ? "اوتماتيك" : "عادي"}
                                        labelPlacement="start"
                                    />
                                </Grid>

                            </Hidden>

                            <Hidden smDown>

                                {!autoNormal && !["149", "150"].includes(setting.PrTy_InPr) ? (downNormalItems()) :
                                    or.postput != "toPut" && setting.PrTy_InPr != "12" && setting.PrTy_InPr != "11" && !["12", "11", "149", "150"].includes(setting.PrTy_InPr) && isdata.length == 0 ?
                                        <Grid
                                            item
                                            style={{
                                                paddingRight: "10px",
                                                color: setting.PrTy_InPr === "03" ? "#964B00" : isPurches ? colors.blue[500] : isStock ? colors.blue[500] : isMake ? colors.blue[500] : colors.green[50],
                                                textAlign: "-webkit-center",
                                            }} >
                                            <IconButton
                                                color="inherit"
                                                style={{
                                                    background: setting.PrTy_InPr === "03" ? "#964B00" : isPurches ? "#008080" : isStock ? "#3f51b5" : isMake ? "#c74375" : colors.green[500],
                                                    padding: "10px",
                                                    color: "#fff",
                                                }}
                                                aria-label="open drawer"
                                                disabled={["149", "150"].includes(setting.PrTy_InPre)}
                                                onClick={(event) => setOpenGetItems(true)}
                                            >
                                                <CloudUpload />
                                            </IconButton>
                                        </Grid> : null}
                            </Hidden>
                            {permistionInv?.DISC_CODE && isdata.length > 0 &&
                                <Hidden mdDown>
                                    <Grid item lg={2} md={2} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <TextField fullWidth variant="outlined" size="small"
                                            id="col1"
                                            label={"كود الخصم"}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                            type="text"
                                            name="Dis_Code"
                                            value={idata.Dis_Code}
                                            onChange={changIdata("Dis_Code")}
                                            InputProps={{
                                                className: claslbl.clrBlackTxt,
                                                onKeyDown: (event) => {
                                                    if (event.key === 'Enter') {
                                                        getCodeDiscount();
                                                    }
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Hidden>
                            }

                            {["149", "150"].includes(setting.PrTy_InPr) && isdata.length > 0 &&
                                <>
                                    <Grid item lg={2} md={2} sm={4} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <Autocomplete
                                            classes={isPurches ? calsPurch : isStock ? clasSaf : clasAo}
                                            value={valueIsharLevel}
                                            onChange={(event, newValue) => {
                                                changAutoIsharLevel(newValue);
                                            }}
                                            id="combo-box-demo"
                                            size="small"
                                            options={IsharLevels}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.name
                                            }

                                            style={{}}
                                            disableClearable
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={"المستوى "}
                                                    variant="outlined"
                                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                                />
                                            )}

                                        />
                                    </Grid>
                                    <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <TextField fullWidth variant="outlined" size="small" id="stay"
                                            label={"مبلغ الاشعار"}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{
                                                className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS :
                                                    claslbls.clrBlackLblSal,
                                            }}
                                            inputProps={{ className: claslbls.clrBlackLblS, }}
                                            type="number"
                                            name="remaining"
                                            disabled={valueIsharLevel?.id === 1}
                                            value={idata?.Ishar_amout}
                                            placeholder="0"
                                            onChange={changeIdataIshar("Ishar_amout")}
                                        /></Grid>
                                    <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <TextField fullWidth variant="outlined" size="small" id="stay"
                                            label={"ضريبة الاشعار"}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{
                                                className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS :
                                                    claslbls.clrBlackLblSal, readOnly: true
                                            }}
                                            inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                            type="number"
                                            name="remaining"
                                            value={idata?.Ishar_Tax ?? 0}
                                            placeholder="0"
                                        /></Grid>
                                    <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <TextField fullWidth variant="outlined" size="small" id="stay"
                                            label={"صافي الاشعار"}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{
                                                className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS :
                                                    claslbls.clrBlackLblSal, readOnly: true
                                            }}
                                            inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                            type="number"
                                            name="remaining"
                                            value={idata?.Ishar_amout_Net ?? 0}
                                            placeholder="0"
                                        /></Grid>
                                </>
                            }
                        </Grid>
                    </React.Fragment>
                    {itmTble()}
                </Container>
                <CssBaseline />
                <div className={classes.root}>

                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            padding: "10px",
                            paddingBottom: "0px",
                            borderBottomColor: isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[300],
                            borderBottomWidth: "1px",
                            borderBottomStyle: "solid",
                        }}
                    >
                    </Container>
                    {footerInvoices()}

                </div>
            </Typography>

        </div>
    );
}
